export const reportsOptions = [
  {
    name: 'fbt business driver',
    displayName: 'SETTINGS.FBT_12_WEEK_DRIVER_REPORT',
  },
  {
    name: 'fbt business vehicle',
    displayName: 'SETTINGS.FBT_12_WEEK_VEHICLE_REPORT',
  },
]
